import React from "react";
import TopPerformerCardChild from "./TopPerformerCardChild";

function TopPerformerCardAdminParent() {
  return (
    <>
      <div className="card-contnent">
        <div className="performer-box">
          <TopPerformerCardChild />
          <TopPerformerCardChild />
        </div>
      </div>
    </>
  );
}

export default TopPerformerCardAdminParent;
